module.exports = __webpack_public_path__ + "img/testimonial-1.2e257755.jpg";